module.exports = __webpack_public_path__ + "img/v.d2e59fbe.svg";